.widget-error-page {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;

  .back {
    position: absolute;
    top: 5px;
    left: 5px;
    .svg-icon {
      font-size: inherit;
      color: inherit;
    }
  }

  .svg-icon {
    margin: 2rem;
    font-size: 2rem;
    color: var(--white);
  }

  p {
    font-size: 1rem;
    line-height: 2rem;

    a {
      font-weight: 700;
      color: var(--secondary);
    }

    &.small {
      font-size: 0.75rem;
    }
  }
}
